import { render, staticRenderFns } from "./doc-item-info.vue?vue&type=template&id=22582b66"
import script from "./doc-item-info.vue?vue&type=script&lang=js"
export * from "./doc-item-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports